<div
  class="status-pill-base"
  [class]="{
    'status-pill-grey': type() === StatusPillType.grey,
    'status-pill-green': type() === StatusPillType.green,
    'status-pill-red': type() === StatusPillType.red,
    'status-pill-yellow': type() === StatusPillType.yellow,
    'status-pill-blue': type() === StatusPillType.blue,
    'status-pill-neutral': type() === StatusPillType.neutral,
    'status-pill-error': type() === StatusPillType.error,
    'status-pill-purple': type() === StatusPillType.purple,
    'status-pill-forbidden': type() === StatusPillType.forbidden,
    'status-pill-light-grey': type() === StatusPillType.lightGrey,
  }">
  @if (error()) {
    <mat-icon svgIcon="error" class="error-icon"></mat-icon>
  }
  <ng-content></ng-content>
</div>
